import { Injectable } from '@angular/core';
import { fabric } from 'fabric';
import { ZoomUtil } from '../common/utils/zoom.util';
import { PASTE_LOCATION_OFFSET } from '../services/wb-copy-paste.service';

@Injectable()
export class ObjectDuplicationUtilsService {
  constructor(private zoomUtil: ZoomUtil) {}

  /**
   * get the location where the new object (duplicated object) should be placed into
   * @param copiedObject
   */
  getPasteLocation(copiedObject: fabric.Object, canvas?: fabric.Canvas): { x: number; y: number } {
    if (!copiedObject.left || !copiedObject.top || !copiedObject.width || !copiedObject.height) {
      return this.zoomUtil.getCenterCoord();
    }

    return {
      x: copiedObject.left + PASTE_LOCATION_OFFSET + copiedObject.width / 2,
      y: copiedObject.top + PASTE_LOCATION_OFFSET + copiedObject.height / 2,
    };
  }

  /**
   * check if the canvas at the current state (considering zoom level) can fit a given object
   */
  canCanvasFitObject(canvas: fabric.Canvas, object: fabric.Object): boolean {
    const objHeight = object.getScaledHeight();
    const objWidth = object.getScaledWidth();
    const zoomLevel = canvas.getZoom();
    const canvasHeight = canvas.getHeight() / zoomLevel;
    const canvasWidth = canvas.getHeight() / zoomLevel;

    return canvasHeight >= objHeight && canvasWidth >= objWidth;
  }
}
